import {Component, EventEmitter, OnInit, ViewEncapsulation} from '@angular/core';
import {CellComponent} from '@shared/components/cell-components/cell-component';
import {InvalidateSubject} from '@shared/helpers/invalidate.subject';
import {FieldDefinition} from '@shared/models/field-definition';

@Component({
    standalone: false,
    selector: 'particle-tax-forms-name-cell-viewer',
  templateUrl: './tax-forms-name-cell-viewer.component.html',
  styleUrls: ['./tax-forms-name-cell-viewer.component.scss'],
  encapsulation: ViewEncapsulation.None

})
export class TaxFormsNameCellViewerComponent implements OnInit, CellComponent {
  sourceType?: string;
  valueChanged?: EventEmitter<any>;
  invalidateSubject?: InvalidateSubject;
  item: any;
  fieldDefinition: FieldDefinition;
  constructor() { }

  ngOnInit() {
  }

}
